export const BUTTON_SIZE = 50

export const BUTTONS_GAP = 10
